//@ts-nocheck
import { makeApiRequest } from "../helpers";
import { APPNAME, APPVER, APP_SOURCE, OSNAME, REACT_APP_API_HEADER_KEY, REACT_APP_TRADEAPIHUB_BASE_URL, REACT_APP_TRADE_API_GATEWAY_KEY, } from "../utils/constant";
import { decryptEnv } from "../helpers";
import { getConfig } from "../config/config";
const { APP_OCP_APIM_KEY, APP_HEAD_KEY } = getConfig();
export const checkLogin = (url) => {
    const cookieString = localStorage.getItem("Cookie") || "";
    if (url.searchParams.get("osName") === "flutter") {
        console.log(cookieString, "cookieString");
        if (!cookieString) {
            console.error("No cookie found in localStorage");
            return;
        }
    }
    return makeApiRequest(`${REACT_APP_TRADEAPIHUB_BASE_URL}checklogresp/Mob/Service1.svc/CheckLoginResponse`, {
        method: "POST",
        credentials: "include",
        headers: {
            "content-type": "application/json",
            "Ocp-Apim-Subscription-Key": decryptEnv(REACT_APP_TRADE_API_GATEWAY_KEY) || "",
            "cookie": cookieString,
        },
        body: JSON.stringify({
            body: {},
            head: {
                appName: APPNAME,
                appSource: APP_SOURCE,
                appVer: APPVER,
                key: decryptEnv(REACT_APP_API_HEADER_KEY) || "",
                osName: OSNAME,
                requestCode: "5PCLRes",
            },
        }),
    });
};
//JaSMYKpkOb1EV9LnfYJYbg==
//G/4txWu/ryzebd+Gq7EXNg==
//YAftqUV3rrXnbuCkD9Z+LA==
export const checkDevLogin = (emailid, password, dob) => {
    return makeApiRequest(`http://gateway.5paisa.in/tradeapi/V5/LoginRequestMobileNewbyEmail`, {
        method: "POST",
        credentials: "include",
        headers: {
            "content-type": "application/json",
            "Ocp-Apim-Subscription-Key": decryptEnv(APP_OCP_APIM_KEY),
            UserID: "Hek68PU5r76",
            Password: "D86utK8Mn7",
        },
        body: JSON.stringify({
            head: {
                appName: APPNAME,
                appVer: APPVER,
                key: decryptEnv(Hek68PU5r76),
                osName: OSNAME,
                requestCode: "5PLoginV5",
            },
            body: {
                Email_id: emailid,
                Password: password,
                VersionNo: "3.1",
                RequestNo: "1",
                My2PIN: dob,
                ConnectionType: "1",
            },
        }),
    });
};
